import { render, staticRenderFns } from "./HorasTrabalhadas.vue?vue&type=template&id=122b82c4&"
import script from "./HorasTrabalhadas.vue?vue&type=script&lang=js&"
export * from "./HorasTrabalhadas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports